import { render, staticRenderFns } from "./RentalProperty.yaml?vue&type=template&id=779b5781&component"
import script from "./RentalProperty.yaml?vue&type=script&lang=ts&component"
export * from "./RentalProperty.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports